import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as moment from "moment";
import { Table } from "reactstrap";
import { BIDFORMAT } from "web/components/utils/dateOfBirthValidation";
import { Form, Formik } from "formik";
import states from "states-us";
import Spinner from "web/components/Spinner";
import { certificateList, taxExemptionApi, deleteTaxExemptionApi, taxExemptFileDownload } from "redux/actions/profile";
import EditTaxExemption from "../EditTaxExemption/index";
import { Tooltip } from "reactstrap";
import information from "web/assets/images/informationIcon.png";
import TextInput from "web/components/form-elements/TextInput";
import Select from "web/components/form-elements/Select";
import { getInitialValues } from "web/components/utils/profileOfficeHourUtils";
import DownloadIcon from "web/assets/svg/DownloadIcon";
import AlertModal from "web/components/AlertModal";
import GetCetModal from "web/components/GetCetModal";
import styled from "styled-components";
import { setCurrentLanguage, fetchLanguageContentNew } from "redux/actions/language";

const UserTaxExemptionForm = ({ pageData, callBackFun, updateButtonDisableState, updateButtonDisableStateToggle }) => {
    const dispatch = useDispatch();
    const authId = localStorage.getItem("authId");
    const token = localStorage.getItem("token");
    const currentLocalization = localStorage.getItem("currentLocalization");
    const formType = localStorage.getItem("formType");
    const isCentralized = localStorage.getItem("isCentralizedPaymentMethod");
    const [imageArrState, setImageArrState] = useState();
    const [alertTypeState, setAlertTypeState] = useState("taxExamption");
    const loaderVisible = useSelector((state) => state.appReducer.loaderVisible);
    let fileArr = [];
    const [tabledata, setTableData] = useState(false);
    const [modal, setModal] = useState(false);
    const [modalContent, setModalContent] = useState("");
    const [modalLink, setModalLink] = useState("");
    const toggleModal = () => setModal(!modal);
    let title = "";
    const [genCetModal, setGenCetModal] = useState(false);
    const genCetToggleModal = () => setGenCetModal(!genCetModal);

    const [editTaxExemptionModal, setEditTaxExemptionModal] = useState(false);
    const toggleEditTaxExemptionModal = () => setEditTaxExemptionModal(!editTaxExemptionModal);

    const currentLanguage = useSelector((state) => state.language.currentLanguage);
    const languageContentNew = useSelector((state) => state.language.languageContentNew);
    const [pageLanguageContents, setPageLanguageContents] = useState();

    const [genCetListResponse, setGenCetListResponse] = useState(undefined);

    useEffect(() => {
        dispatch(fetchLanguageContentNew(currentLocalization));
        dispatch(setCurrentLanguage(currentLocalization));
    }, [currentLanguage]);

    useEffect(() => {
        if (languageContentNew?.H8_Nav_Profile_Page) setPageLanguageContents(languageContentNew.H8_Nav_Profile_Page);
    }, [languageContentNew]);

    useEffect(() => {
        getCertTableDataAPI();
    }, []);

    const getCertTableDataAPI = async () => {
        let response = await dispatch(certificateList(token, authId));
        setGenCetListResponse(response.value);
    };

    const territoryStates = states.filter((x) => x.contiguous);
    let stateArr = [];
    for (let i = 0; i < territoryStates.length; i++) {
        if (territoryStates[i].name !== 'District Of Columbia') {
            let obj = {
                value: territoryStates[i].name,
                label: `${territoryStates[i].abbreviation}-${territoryStates[i].name}`,
                isoCode: territoryStates[i].abbreviation,
            };
            stateArr.push(obj);
        }
    }

    const [tooltipOpenOne, setTooltipOpenOne] = useState(false);
    const iIcon = (infoTxt) => {
        return (
            <>
                <img
                    id="TooltipOne"
                    src={information}
                    style={{
                        paddingLeft: "5px",
                        position: "relative",
                        top: "-1px",
                    }}
                />
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpenOne}
                    target="TooltipOne"
                    toggle={() => setTooltipOpenOne(!tooltipOpenOne)}
                >
                    {infoTxt}
                </Tooltip>
            </>
        );
    };
    const uploadImageTaxExemption = async (props, type, data) => {
        let taxExemptionExpireDate, stateTaxExemption;

        if (type === "addTaxExemption") {
            if (!props.values.taxExemptionExpireDate) {
                taxExemptionExpireDate = pageData.userDetails.taxExemptionExpireDate;
            } else {
                taxExemptionExpireDate = moment(
                    props.values.taxExemptionExpireDate
                ).format(BIDFORMAT);
            }
            stateTaxExemption = props.values.stateTaxExemption;
        } else {
            taxExemptionExpireDate = moment(
                props.values.editTaxExemptionExpireDate
            ).format(BIDFORMAT);
            stateTaxExemption = props.values.editStateTaxExemption;
        }

        let imageVal = imageArrState;
        if (pageData.userDetails?.taxExemption && !imageArrState) {
            imageVal = "";
        }
        let formData = new FormData();

        if (type === "editTaxExemption" && !imageArrState) {
            imageVal = data.fileName;
        }
        if (!imageVal && type === "addTaxExemption") {
            setModalContent("Please upload a tax exemption form.");
            setAlertTypeState("taxExamptionFailure");
            setModalLink("");
            toggleModal();
        } else {
            let obj = {
                state: stateTaxExemption,
                taxExemption: imageVal,
                taxExemptionExpireDate: taxExemptionExpireDate,
            };
            const propsData = obj;
            for (let prop in propsData) {
                formData.append(prop, propsData[prop]);
            }
            let taxResponse = await dispatch(taxExemptionApi(formData, token));
            if (taxResponse.status === "SUCCESS") {
                setAlertTypeState("taxExamption");
                setModalContent("Tax exempt form has been successfully updated.");
                setModalLink("");
                toggleModal();
            } else {
                setModalContent(taxResponse.message);
                setAlertTypeState("taxExamptionFailure");
                setModalLink("");
                toggleModal();
            }
        }
    };

    const downloadTaxForm = async (genCetId) => {
        const urlPath = "/order/tax/download_certificate?id=" + authId + "&c_id=" + genCetId;
        let response = await dispatch(taxExemptFileDownload(token, urlPath));

        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", "taxExemptForm.pdf");
        document.body.appendChild(link);
        link.click();
    };

    const deleteTaxExemption = async (state) => {
        let response = await dispatch(deleteTaxExemptionApi(state, token));
        if (response.status === "SUCCESS") {
            setAlertTypeState("taxExamption");
            setModalContent(response.message);
            setModalLink("");
            toggleModal();
        } else {
            setModalContent(response.message);
            setAlertTypeState("taxExamptionFailure");
            setModalLink("");
            toggleModal();
        }
    };

    let dependentFlag = false;
    if (
        localStorage.getItem("handlePayment") === "true" &&
        localStorage.getItem("location") === "MAIN" &&
        formType !== "CORPORATE_SUBACC" &&
        isCentralized === "false"
    ) {
        dependentFlag = true;
    }
    if (
        localStorage.getItem("handlePayment") === "false" &&
        localStorage.getItem("location") === "SUBSIDIARY" &&
        formType === "CORPORATE_SUBACC"
    ) {
        dependentFlag = true;
    }
    if (
        localStorage.getItem("handlePayment") === null &&
        localStorage.getItem("location") === "SUBSIDIARY" &&
        formType === "CORPORATE_SUBACC" &&
        isCentralized === "false"
    ) {
        dependentFlag = true;
    }

    return (
        <>
            {loaderVisible && <Spinner />}
            {pageData && (
                <Formik
                    initialValues={getInitialValues(pageData)}
                    onSubmit={(values) => { }}
                >
                    {(props) => {
                        const { isValid, dirty, values, errors, touched, setFieldValue } = props;
                        return (
                            <>
                                <Form>
                                    <div>
                                        <div className="row mt-2">
                                            <span className="separator-line" style={{ width: "100%", borderTop: "1px solid #87cdf1", margin: "10px 16px 30px 16px" }}></span>
                                            <div className="col-sm-12">
                                                <h5
                                                    className="border-bottom pb-3 mb-3"
                                                    style={{ "font-family": "latobold", "font-size": "22px", }}
                                                >
                                                    {pageLanguageContents?.Tax_Exemption[0]?.Title}
                                                    {iIcon(pageLanguageContents?.Tax_Exemption[21]?.TaxExemptionPopUp)}
                                                </h5>
                                            </div>
                                            <div className="col-sm-4 col-md-4 form-group">
                                                <label htmlFor="" className="form-label">
                                                    {pageLanguageContents?.Tax_Exemption[3]?.State}
                                                    <span className="star">&#42;</span>
                                                </label>
                                                {pageData?.userDetails?.locationType === 'DEP' ? (
                                                    <TextInput
                                                        name="stateTaxExemption"
                                                        placeholder="State"
                                                        showErrorMessages={true}
                                                        disabled={true}
                                                    />
                                                ) : (
                                                    <Select
                                                        name="stateTaxExemption"
                                                        data={stateArr}
                                                        placeholder="State"
                                                        searchable={true}
                                                        isDisabled={true}
                                                        onChangeHandler={(data) => { }}
                                                    />
                                                )}
                                            </div>
                                            {pageData?.userDetails?.locationType === 'DEP' ? "" : (
                                                <TaxExemption className="col-sm-4 col-md-4">
                                                    <label className="form-label">&nbsp;</label>
                                                    <button
                                                        className="button app-green-button ml-auto"
                                                        onClick={(e) => {
                                                            if (props.values?.stateTaxExemption) {
                                                                genCetToggleModal();
                                                            } else {
                                                                setModalContent("Please select state first.");
                                                                setModalLink("");
                                                                toggleModal();
                                                            }
                                                        }}
                                                    >
                                                        Exemption Form
                                                    </button>
                                                </TaxExemption>
                                            )}

                                            <div className="col-sm-12">
                                                <DataRow className="row">
                                                    <Table responsive>
                                                        <thead>
                                                            <tr>
                                                                <th>State</th>
                                                                <th>Signed Date</th>
                                                                <th>Expiration Date</th>
                                                                <th>Status</th>
                                                                <th
                                                                    className="text-center"
                                                                    style={{ width: "137px" }}
                                                                >
                                                                    Document
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {genCetListResponse?.map((data, index) => {
                                                                return (
                                                                    <tr>
                                                                        <th>{data.exposureZone.name}</th>
                                                                        <th>{data.signedDate}</th>
                                                                        <th>{data.expirationDate}</th>
                                                                        <th>{data.status}</th>
                                                                        <th className="text-center">
                                                                            <button
                                                                                className="download-btn"
                                                                                onClick={() =>
                                                                                    downloadTaxForm(data.id)
                                                                                }
                                                                            >
                                                                                <DownloadIcon />
                                                                            </button>
                                                                        </th>
                                                                    </tr>
                                                                );
                                                            })}
                                                        </tbody>
                                                    </Table>
                                                </DataRow>
                                            </div>
                                        </div>
                                    </div>
                                </Form>

                                {pageLanguageContents && (
                                    <EditTaxExemption
                                        isOpenTaxExm={editTaxExemptionModal}
                                        toggleTaxExm={toggleEditTaxExemptionModal}
                                        fileArr={fileArr}
                                        pageLanguageContents={pageLanguageContents}
                                        imageArrState={imageArrState}
                                        tabledata={tabledata}
                                        uploadDocument={(imageArr) => {
                                            setImageArrState(imageArr);
                                        }}
                                        updateCallBack={(props, imageArr) => {
                                            uploadImageTaxExemption(props, "editTaxExemption", tabledata);
                                        }}
                                    />
                                )}

                                {genCetModal && (
                                    <GetCetModal
                                        isOpen={genCetModal}
                                        toggle={genCetToggleModal}
                                        title={""}
                                        selectedState={props.values?.stateTaxExemption}
                                        onClickHander={(val) => {
                                            genCetToggleModal();
                                        }}
                                        callBack={() => {
                                            getCertTableDataAPI();
                                            genCetToggleModal();
                                        }}
                                        content={""}
                                        link={""}
                                    />
                                )}

                            </>
                        );
                    }}
                </Formik>
            )}

            <AlertModal
                isOpen={modal}
                toggle={toggleModal}
                title={title}
                content={modalContent}
                alertType={alertTypeState}
                link={modalLink}
                callBackAlert={(val) => {
                    if (val !== "failure") {
                        window.location.reload();
                    }
                }}
            />
        </>
    );
};

export default UserTaxExemptionForm;

const TaxExemption = styled.div`
  /* margin: 25px 0; */
  .error-message-multiple {
    position: unset;
    white-space: normal;
  }
  .uploadPhoto {
    > div {
      margin: 12px auto !important;
      justify-content: space-between;
    }
  }
  .multiple-file-input {
    margin: 0;
    .custom-file-input {
      max-width: 100%;
    }
    .text {
      width: 100%;
    }
    @media (max-width: 575px) {
      .uploadPhoto {
        justify-content: flex-end;
        > div {
          max-width: 266px;
        }
      }
    }
  }
`;

const DataRow = styled.div`
  padding: 0 15px;
  overflow: auto;
  .download-btn {
    border: none;
    background: linear-gradient(to bottom, #61b01f 0%, #27911b 100%);
    border-radius: 5px;
    padding: 0;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 38px;
    height: 28px;
  }
  .table-responsive {
    max-height: 330px;
    thead {
      position: sticky;
      top: 0;
      background: #fff;
      width: 100%;
    }
  }
  .table thead tr th {
  }
  .table thead tr th.last-child {
    width: 108px;
  }
  .table tbody th {
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #191819;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 240px;
    .edit-btn {
      cursor: pointer;
    }
    .action-col {
      display: flex;
      align-items: center;
      .delete-icon {
        max-width: 22px;
        cursor: pointer;
        margin-left: 15px;
      }
    }
  }
  .table thead th {
    border-top: none;
    border-width: 1px;
    vertical-align: top;
  }
  .edit-button {
    width: 167px;
    margin-top: 25px;
  }
  @media (max-width: 600px) {
    margin: 20px 0;
  }
`;
